module.exports = __webpack_public_path__ + "img/redemption.e0dc8caa.svg";